// -----------------------------------------------------------------------------
// Date utilities
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

/**
 * Calcule le nombre de jours restants jusqu'à une date limite (DLC).
 * @param {string|Date|null} dlc - Date limite de consommation
 * @returns {number|null} Nombre de jours restants (peut être négatif), ou null si pas de DLC
 */
export const daysUntil = (dlc) => {
  if (!dlc) return null;
  return Math.ceil((new Date(dlc) - new Date()) / 86400000);
};
